import { Toaster } from "@fluentui/react-components";

import { NOTIFY_TOASTER_ID } from "./notifyToasterId";

/**
 * アプリ共通トーストの表示器。`FluentProvider` 配下のアプリルートに 1 つ置き、
 * 任意のコンポーネントから `useNotify()` で通知を出す ([[アドイン開発規則]] エラー表示＝トースト/バナー)。
 */
export function NotifyToaster() {
    return <Toaster toasterId={NOTIFY_TOASTER_ID} position="bottom-end" />;
}
